import { FieldTable } from '@tj/tj-dmp-lib-api';

export const parseType = (valueType: FieldTable.CategoryFieldEnum, variableType: FieldTable.TypeEnum) => {
    switch (valueType) {
        case "ACTIVITY_STATUS":
        case "LOYALTY_STATUS":
        case "PURCHASE_STATUS":
        case "CHANNEL":
        case "PRODUCT_TYPE":
        case "IATA_CITY":
        case "IATA_AIRPORT":
        case "IATA_COUNTRY":
        case "LANG":
        case "COUNTRY":
        case "CIVILITY":
        case "CARRIER":
            return "list"
        case "NEWSLETTER":
            return "newsletter";
        case "PRICE":
        case "NUMBER":
        case "DATE":
        case "DATE_TIME":
        case "PHONE":
        case "MOBILE":
        case "TEXT":
        case "EMAIL":
        case "TECHNICAL":
        case "AFFILIATION":
        case "BOOKING_REFERENCE":
        default:
            switch (variableType) {
                case 'TEXT':
                case 'String255':
                case 'String25':
                case 'String3':
                case 'String100':
                case 'String10':
                case 'String50':
                case 'UUID':
                    return 'string';
                case 'Int':
                case 'BigInt':
                case 'Decimal_5_2':
                case 'Decimal_8_2':
                case 'Decimal_11_2':
                    return 'number';
                case 'Boolean':
                    return 'boolean';
                case 'DateTime':
                case 'Date':
                case 'Time':
                    return 'date';
                default:
                    return 'string';
            }
    }
};
